// extracted by mini-css-extract-plugin
export default {"tableButtons":"StaffTable_tableButtons__L0Zl0","admin":"StaffTable_admin__3FrhZ","manager":"StaffTable_manager__Z2VVz"};